enum MODALS {
  Approve = "Approve",
  Absence = "Absence",
  RequestAbsence = "RequestAbsence",
  AbsenceType = "AbsenceType",
  ProstheticReport = "ProstheticReport",
  ProstheticReportRecord = "ProstheticReportRecord",
  Holiday = "Holiday",
  Clinic = "Clinic",
  Chair = "Chair",
  Schedule = "Schedule",
  Laboratory = "Laboratory",
  Supplier = "Supplier",
  Category = "Category",
  Timesheet = "Timesheet",
  Roentgen = "Roentgen",
  RoentgenReport = "RoentgenReport",
  RoentgenReportRecord = "RoentgenReportRecord",
  Material = "Material",
  TimesheetEvent = "TimesheetEvent",
  Apartment = "Apartment",
  ReserveApartment = "ReserveApartment",
  WarehouseAddItems = "WarehouseAddItems",
  AddToCart = "AddToCart",
  OrderNumber = "OrderNumber",
  ReceivedItemCount = "ReceivedItemCount",
  WarehouseTakeItems = "WarehouseTakeItems",
  DailySheetReport = "DailySheetReport",
  DailySheetReportRecord = "DailySheetReportRecord",
}

export default MODALS;
